import script from "./index-web.vue?vue&type=script&lang=ts&setup=true"
export * from "./index-web.vue?vue&type=script&lang=ts&setup=true"

import "./index-web.vue?vue&type=style&index=0&id=ae84ec86&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae84ec86"]])

export default __exports__